<template>
  <div>
    <iframe :src="src"  width="100%" :height="ModelHeight" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: window.location.origin + "/#/userViewModelIfram",
      ModelHeight: document.body.clientHeight - 90,
    };
  },
  created() {
    this.flushSession();
  },
  mounted() {

  },
};
</script>
<style scoped>
/* 新增 */
.padding-30p {
  padding: 30px;
}
</style>
